import type { LotteryName } from '../../../lottery-purchases/types';
import { getLiveDrawBallsEndMs } from '../../liveDraw/getLiveDrawRevealTiming';

/**
 * How many balls the public live-draw sequence reveals, including extras.
 *
 * Daily Million draws 6. Lucky for Life draws 6 main numbers plus the Lucky ball.
 */
const LIVE_DRAW_DRAWN_BALLS: Partial<Record<LotteryName, number>> = {
  theDailyMillion: 6,
  luckyForLife: 7,
};

/**
 * Calculate the duration of the live draw in progress status for each lottery.
 *
 * It matches the public Live Draw sequence (countdown, ball clips, and the gap between balls).
 * This calculation is not extended by the win lead or `ANNOUNCE_WIN_MS` for a player with a winning ticket.
 */
function getLiveDrawInProgressDuration(lotteryName: LotteryName): number | undefined {
  const drawnBalls = LIVE_DRAW_DRAWN_BALLS[lotteryName];
  if (drawnBalls == null) {
    return undefined;
  }

  return getLiveDrawBallsEndMs(drawnBalls);
}

export { getLiveDrawInProgressDuration };
